import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges, forwardRef } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

import { SelectItem } from '../../models/index';

import { Observable } from 'rxjs';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/map';
import { ApiService } from 'shared/services';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

@Component({
    selector: 'typeahead-select',
    templateUrl: './typeahead-select.component.html',
    styleUrls: ['./typeahead-select.component.scss'],
    providers: [
        { 
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => TypeaheadSelectComponent),
        multi: true
        }
    ]
})
export class TypeaheadSelectComponent implements OnInit, ControlValueAccessor {
	/*@Input()  emptyOption: boolean = false;
	@Input()  emptyOptionText: string = "";*/
	@Input()  required: boolean = false;
	@Input()  disabled: boolean = false;
	@Input()  options: SelectItem[] = [];
	@Input()  placeholder: string = "";
	@Input()  id: string = "";
	@Input()  name: string = "";
    @Input()  filterOn: string;
    @Input()  service: ApiService<any>;
    @Input()  serviceFunc: string = 'loadItems';
    @Input()  serviceArrayFunc: string = 'selectItemArray';
	@Input()  iValue: number;
    @Output() iValueChange: EventEmitter<number> = new EventEmitter();
    
    propagateChange = (_: any) => {};

	/*@Input() set iValue(value: number) {
		if(value) {
			this.selected = this._options.filter(v => v.value == value)[0]; //this.iValue
			this.lastSelected = this.selected;
		}
	}

	@Input() set filterOn(value: string) {
		if(value) {
			this._options = this.options.filter(v => (!v.filterable || v.filterable == value));

			this.selected = this._options.filter(v => v.value == this.iValue)[0];
			this.lastSelected = this.selected;
		}
	}*/

	lastSelected: SelectItem;
	selected: SelectItem;

	dropdownVisible: boolean = false;

    _options: SelectItem[] = [];
    
    loaded: boolean = false;

	ngOnChanges(changes: SimpleChanges) {

		if(changes.options) {
			this._options = changes.options.currentValue;
		}

		if(changes.iValue) {
            this.setSelected(changes.iValue.currentValue);			
		}

		if(changes.filterOn) {
			this._options = this.options.filter(v => (!v.filterable || v.filterable == changes.filterOn.currentValue));

			this.selected = this._options.filter(v => v.value == this.iValue)[0];
			this.lastSelected = this.selected;
		}

	}

    // Control value accessor
    writeValue(value: any): void {
        if (value) {
            this.setSelected(value);
        }
    }
    
    registerOnChange(fn: any): void {
        this.propagateChange = fn;
    }

    registerOnTouched(fn: any): void { }
    setDisabledState?(isDisabled: boolean): void { }

    ngOnInit() {
        if(this.service) {
        	if(!this.service[this.serviceFunc]) {
        		console.error('Function not found', this.serviceFunc, this.service);
        		return;
        	}
        	if(!this.service[this.serviceArrayFunc]) {
        		console.error('Function not found', this.serviceArrayFunc, this.service);
        		return;
        	}
            this.service[this.serviceFunc]().subscribe(response => {
                this._options = this.service[this.serviceArrayFunc]();
                this.loaded = true;

                if(this.iValue) {
                    this.setSelected(this.iValue);
                }
            });
        } else {
            this.loaded = true;
        }
    }
    
    setSelected(value: number) {
        this.selected = this._options.filter(v => v.value == value)[0];
        this.lastSelected = this.selected;
    }

	showDropdown() {
		this.dropdownVisible = true;
		if(this.dropdownTimer) {
			clearTimeout(this.dropdownTimer);
		}
	}

	dropdownTimer: any;

	hideDropdown() {
		this.dropdownTimer = setTimeout (() => {
			this.dropdownVisible = false;
			this.dropdownTimer = null;
		}, 1000);

	}

	onBlur() {
		if(!this.selected) {
			this.selected = this.lastSelected;
		}
	}

	select(item: SelectItem) {
		this.selected = item;
		this.lastSelected = this.selected;
        this.iValueChange.emit(this.selected.value);
        this.propagateChange(this.selected.value);
	}

	formatter = (x: SelectItem) => x.label;

	search = (text$: Observable<string>) =>
		text$
		.debounceTime(200)
		.distinctUntilChanged()
		.map(term => this._options.filter(v => v.label.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10))
		/*.map(term => term.length < 2 ? []
			: this._options.filter(v => v.label.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10))*/;

}



// WEBPACK FOOTER //
// /var/www/vhosts/s-wines.nl/httpdocs/crm/resources/assets/src/app/shared/components/typeahead-select/typeahead-select.component.ts